import React, { useState } from "react";
import AreaQualifierClassView from './area-qualifier-class-view';
import AreaQualifierRegionView from './area-qualifier-region-view';
import AreaQualifierGeoView from './area-qualifier-geo-view';
export const GROUP_MODES = {
  CLASS: 'class',
  REGION: 'region',
  GEOGRAPHY: 'geo'
};
const AreaQualifierView = ({
  areas,
  classes,
  year
}) => {
  const [groupMode, setGroupMode] = useState(GROUP_MODES.CLASS);
  const baseGroupClass = `group group hover:bg-accent border-jacarta-100 font-display text-jacarta-700 flex h-9 items-center rounded-lg border px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white`;
  const generateGrouplasses = mode => mode === groupMode ? `${baseGroupClass}  bg-accent border-transparent text-white` : `${baseGroupClass} bg-white`;
  const renderGroup = mode => {
    switch (mode) {
      case GROUP_MODES.CLASS:
        return <AreaQualifierClassView classes={classes} />;
      case GROUP_MODES.REGION:
        return <AreaQualifierRegionView areas={areas} />;
      case GROUP_MODES.GEOGRAPHY:
        return <AreaQualifierGeoView areas={areas} year={year} />;
      default:
        return <div>Unknown View Mode</div>;
    }
  };
  return <>
			<div className="mb-8 flex flex-wrap items-center justify-between">
				<div className="flex flex-wrap items-center">
					<div className="my-1 mr-2.5 relative">
						<button onClick={() => setGroupMode(GROUP_MODES.CLASS)} className={generateGrouplasses(GROUP_MODES.CLASS)}>
							<span>By Class</span>
						</button>
					</div>
					<div className="my-1 mr-2.5 relative">
						<button onClick={() => setGroupMode(GROUP_MODES.REGION)} className={generateGrouplasses(GROUP_MODES.REGION)}>
							<span>By Region</span>
						</button>
					</div>
					<div className="my-1 mr-2.5 relative">
						<button onClick={() => setGroupMode(GROUP_MODES.GEOGRAPHY)} className={generateGrouplasses(GROUP_MODES.GEOGRAPHY)}>
							<span>Map View</span>
						</button>
					</div>
				</div>
			</div>

			{renderGroup(groupMode)}
		</>;
};
export default AreaQualifierView;